import { apiService } from './api';

export interface User {
  user_id: string;
  email: string;
  username: string;
  created_at: string;
  status: string;
  email_verified: boolean;
}

export interface UserStats {
  total_hunts_completed: number;
  total_points: number;
  level: number;
}

class UserService {
  // Get all users
  async getAllUsers(): Promise<User[]> {
    const response: any = await apiService.get('/admin/users');
    return response.users || [];
  }

  // Get user by ID
  async getUser(userId: string): Promise<User> {
    const response = await apiService.get<{ success: boolean; data: User }>(`/users/${userId}`);
    return response.data;
  }

  // Get user stats
  async getUserStats(userId: string): Promise<UserStats> {
    const response = await apiService.get<{ success: boolean; data: UserStats }>(`/users/${userId}/stats`);
    return response.data;
  }

  // Update user status (admin only)
  async updateUserStatus(userId: string, status: string): Promise<User> {
    const response = await apiService.put<{ success: boolean; data: User }>(
      `/admin/users/${userId}/status`,
      { status }
    );
    return response.data;
  }

  // Delete user (admin only)
  async deleteUser(userId: string): Promise<void> {
    await apiService.delete(`/admin/users/${userId}`);
  }
}

export const userService = new UserService();
